import { render, staticRenderFns } from "./AddEditItems.vue?vue&type=template&id=a77bcc66&scoped=true&"
import script from "./AddEditItems.vue?vue&type=script&lang=js&"
export * from "./AddEditItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77bcc66",
  null
  
)

export default component.exports